import type { Format } from "@roxpacer/core";
import { useRef, useState } from "react";
import { downloadPlan, parsePlanFile } from "../lib/plan-file";
import { useActivePlan, usePlans } from "../store";

export function PlanToolbar() {
  const plans = usePlans((s) => s.plans);
  const activeId = usePlans((s) => s.activeId);
  const { selectPlan, newPlan, duplicateActive, deleteActive, importPlan } = usePlans();
  const plan = useActivePlan();
  const fileInput = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string | null>(null);

  const onImport = async (file: File | undefined) => {
    if (!file) return;
    const result = parsePlanFile(await file.text());
    if (result.ok) {
      importPlan(result.plan);
      setError(null);
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-2">
        <select
          aria-label="Saved plans"
          className="field w-full sm:w-64"
          value={activeId}
          onChange={(e) => selectPlan(e.target.value)}
        >
          {plans.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
        <select
          aria-label="New plan"
          className="btn btn-primary appearance-none"
          value=""
          onChange={(e) => {
            if (e.target.value) newPlan(e.target.value as Format);
          }}
        >
          <option value="">+ New plan</option>
          <option value="singles">Singles</option>
          <option value="doubles">Doubles</option>
          <option value="relay">Relay</option>
        </select>
        <button type="button" className="btn" onClick={duplicateActive}>
          Duplicate
        </button>
        <button type="button" className="btn" onClick={() => downloadPlan(plan)}>
          Export
        </button>
        <button type="button" className="btn" onClick={() => fileInput.current?.click()}>
          Import
        </button>
        <button
          type="button"
          className="btn text-danger"
          onClick={() => {
            if (confirm(`Delete “${plan.name}”? This can't be undone.`)) deleteActive();
          }}
        >
          Delete
        </button>
        <input
          ref={fileInput}
          type="file"
          accept="application/json,.json"
          className="hidden"
          data-testid="import-input"
          onChange={(e) => {
            void onImport(e.target.files?.[0]);
            e.target.value = "";
          }}
        />
      </div>
      {error && (
        <p role="alert" className="text-sm text-danger">
          {error}
        </p>
      )}
    </div>
  );
}
